module.exports = __webpack_public_path__ + "static/img/jyyx.fb642283.png";